import React, { useEffect, useState } from "react";
import * as apiHelper from "../../Services/ApiHelper";
import * as toast from "../../Wrapper/toast/toast";
import AlertMedicineUI from "./AlertMedicineUI";
import { useLocation } from "react-router-dom";
const AlertMedicine = () => {
  const [medicineList, setMedicineList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const { state } = useLocation();
  const id = state?.id;
  const type = state?.type;
  const stock = state?.stock;
  const expiry = state?.expiry;

  useEffect(() => {
    getMedicineList();
  }, []);
  const onPageChange = (page) => {
    getMedicineList(page);
  };

  const getMedicineList = (page = 1) => {
    let query = {
      page: page,
      limit: 10,
      id,
    };
    setLoading(true);
    apiHelper
      .getAlertMedicineList(query)
      .then((response) => {
        if (response?.isSuccess) {
          setMedicineList(response?.data);
          if (response?.data?.data.length < 1) {
            setError(response?.message);
          }
        } else {
          toast.warn(response?.message);
        }
      })
      .catch((err) => toast.warn(err))
      .finally(() => setLoading(false));
  };

  return (
    <AlertMedicineUI
      loading={loading}
      list={medicineList}
      onPageChange={onPageChange}
      error={error}
      type={type}
      stock={stock}
      expiry={expiry}
    />
  );
};
export default AlertMedicine;
